import * as Sentry from '@sentry/react';
import axios from 'axios';

import {replaceFileExtension} from '@edume/bento/fileUtil';
import * as mediaModule from '@edume/bento/media.browser';
import {getYouTubeIdFromUrl} from '@edume/bento/videoUtil.browser';

import config from '../config';
import edumeClient from '../edumeClient';

const defaultMediaUrl = '/resources/img/default_course_image.png';

export const CANCELLED_COMPONENT_UNMOUNTED = 'CANCELLED_COMPONENT_UNMOUNTED';

// https://stackoverflow.com/a/59985954/5915221
export const readURL = (file) =>
  new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = (e) => res(e.target.result);
    reader.onerror = (e) => rej(e);
    reader.readAsDataURL(file);
  });

export const handleImageUpload = (file, cancelTokenSource) =>
  mediaModule.handleImageUpload(
    edumeClient,
    file,
    {
      cloudinaryUploadPreset: config.cloudinaryUploadPreset,
    },
    axios,
    cancelTokenSource,
    Sentry
  );

export const handleVideoUpload = (file, cancelTokenSource) =>
  mediaModule.handleVideoUpload(
    edumeClient,
    file,
    {
      cloudinaryUploadPreset: config.cloudinaryUploadPreset,
    },
    axios,
    undefined,
    cancelTokenSource,
    Sentry
  );

export const getImageDimensions = (url) =>
  new Promise((res, rej) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      res({width: image.width, height: image.height});
    };
    image.onerror = (e) => rej(e);
  });

export const getPreviewImage = (url, type) => {
  if (!url) {
    return defaultMediaUrl;
  }
  const youtubeId = getYouTubeIdFromUrl(url);
  if (youtubeId) {
    return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
  }
  return type === 'image'
    ? url
    : //cloudinary supports changing video extension to jpg to get default thumbnail
      `${mediaModule.CLOUDINARY_VIDEO_URL_PREFIX}${replaceFileExtension(
        url,
        'jpg'
      )}`;
};

export const getPrivacyOfYouTubeVideo = async (id) => {
  const apiKey = config.youtubeApiKey;
  const url = `https://www.googleapis.com/youtube/v3/videos?id=${id}&part=status&key=${apiKey}`;
  try {
    const response = await axios.get(url, {
      headers: {Accept: 'application/json'},
    });
    if (response.data && response.data.items.length) {
      const privacy = response.data.items[0].status.privacyStatus;
      return privacy;
    } else {
      throw new Error('Video not found');
    }
  } catch (error) {
    console.error(error);
    throw new Error('Error getting video');
  }
};

export const truncateStringFromEnd = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str;
  }
  return '...' + str.slice(-maxLength);
};

export const truncateVideoURL = (videoUrl, maxLength) => {
  try {
    const url = new URL(videoUrl);
    const {host, pathname, search} = url;
    let name = `${host}${pathname}${search}`;
    name = name.split('www.')[1] ?? name;
    if (name.length <= maxLength) {
      return name;
    }
    return name.substring(0, maxLength) + '...';
  } catch {
    // Create fall back for partial cloudinary url
    return truncateStringFromEnd(videoUrl, maxLength);
  }
};
